import React from "react";
import RadioGroup from "../../../shared/RadioGroup";
import ID from "./ID";


export default class CustomMultipleChoices extends React.Component {

    constructor(props) {
        super(props);
        let currentValue = props.defaultValue;
        this.state = {
            options: [],
            selectedAnswer: null,
            defaultAnswer: currentValue
        }
        this.onChange = this.onChange.bind(this);

    }

    onChange(value) {

        if (value) {
            this.setState({
                selectedAnswer: value
            })

        }
    }


    render() {
        let uuid = ID.uuid();
        return (
            <>
                <input {...this.props} id={"custom-multi-choices"} value={this.state.selectedAnswer ? this.state.selectedAnswer : this.state.defaultAnswer} type={"hidden"}/>

                <RadioGroup
                    name={"q1" + uuid}
                    label=""
                    disabled={this.props.disabled}
                    options={this.props.data.options}
                    value={this.state.selectedAnswer? this.state.selectedAnswer : this.state.defaultAnswer}
                    onChange={this.onChange}
                />

            </>
        )
    }

}